<section [ngClass]="this.router.url === '/home' ? 'contact-form-main' : 'contact-form-main section-padding30'">
  @if (this.router.url === '/home') {
  <div class="container">
    <div class="row align-items-end justify-content-between">
      <div class="col-lg-6 col-md-9 col-sm-9 col-12">
        <div class="section-title">
          <span>Contattaci</span>
        </div>
      </div>
    </div>
  </div>
  } @else {
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-9 col-sm-9 col-12">
        <div class="section-title text-center">
          <h1>Contattaci</h1>
        </div>
      </div>
    </div>
  </div>
  }
  <div class="row mx-3">
    <!-- <div class="col-lg-6 col-md-6 col-xs-12">
      <div id="map" class="map-responsive">
        <iframe *ngIf="sede === 'fonte-laurentina'"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2974.6068023283174!2d12.49112867538139!3d41.79368687069614!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13258b867272471f%3A0x125b1e87233b7902!2sV.le%20Leonida%20Tonelli%2C%2084%2C%2000134%20Roma%20RM!5e0!3m2!1sit!2sit!4v1750520488000!5m2!1sit!2sit"
          allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        <iframe *ngIf="sede === 'trigoria'"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1761.9859192012366!2d12.477924192720069!3d41.769847486029775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13258cf4936d9fd5%3A0x1a3edf9811880332!2sVia%20di%20Trigoria%2C%2057%2C%2000128%20Roma%20RM!5e0!3m2!1sit!2sit!4v1764856577904!5m2!1sit!2sit"
          width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"></iframe>

      </div>
    </div> -->

    <div class="col-lg-12 col-md-12 col-xs-12">
      <div class="contact-form">
        <form id="contact-form" [formGroup]="f" (ngSubmit)="onSubmit(f.value)">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="form-box mb-30">
                <select name="sede" formControlName="sede" class="form-select">
                  <option value="" disabled selected>Seleziona la sede</option>
                  <option *ngFor="let s of sedi" [value]="s.id">
                    {{ s.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <div class="form-box user-icon mb-30">
                <input type="text" name="nome" placeholder="Nome" formControlName="nome">
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <div class="form-box user-icon mb-30">
                <input type="text" name="cognome" placeholder="Cognome" formControlName="cognome">
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <div class="form-box email-icon mb-30">
                <input class="text-lowercase" type="Email" name="mail" placeholder="Email" formControlName="mail">
              </div>
            </div>

            <div class="col-lg-12">
              <div class="form-box message-icon mb-65">
                <textarea name="note" id="message" placeholder="Messaggio" formControlName="note"></textarea>
              </div>
              <div class="submit-info">
                <button class="btn" type="submit">Invia mail</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>